declare namespace $ {

	type $mol_view__sub_easyreels_user_upload_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_open_native__files_easyreels_user_upload_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_upload['files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_easyreels_user_upload_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_easyreels_user_upload_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_button_open__sub_easyreels_user_upload_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_portion__portion_easyreels_user_upload_6 = $mol_type_enforce<
		ReturnType< $easyreels_user_upload['ratio'] >
		,
		ReturnType< $mol_portion['portion'] >
	>
	type $mol_paragraph__title_easyreels_user_upload_7 = $mol_type_enforce<
		ReturnType< $easyreels_user_upload['message'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_upload_8 = $mol_type_enforce<
		ReturnType< $easyreels_user_upload['detail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_easyreels_user_upload_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_easyreels_user_upload_10 = $mol_type_enforce<
		ReturnType< $easyreels_user_upload['retry'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $easyreels_user_upload extends $mol_view {
		Pick_icon( ): $mol_icon_upload
		pick_title( ): string
		Pick_title( ): $mol_view
		Pick_native( ): $mol_button_open_native
		Pick( ): $mol_button_open
		ratio( ): number
		Bar( ): $mol_portion
		message( ): string
		Message( ): $mol_paragraph
		detail( ): string
		Detail( ): $mol_paragraph
		Retry_button( ): $mol_button_minor
		content( ): readonly($mol_view)[]
		files( next?: readonly(File)[] ): readonly(File)[]
		retry( next?: any ): any
		sub( ): ReturnType< $easyreels_user_upload['content'] >
	}
	
}

//# sourceMappingURL=upload.view.tree.d.ts.map